import React from "react";

import "./CurrentOrders.css";
import { useTranslation } from "react-i18next";

const CurrentOrdersList = () => {
  const { t } = useTranslation("common");
  const orderTableTitles = [
    { id: 1, label: t("Order Number") },
    { id: 1, label: t("Reseller") },
    { id: 3, label: t("Total Amount") },
    { id: 4, label: t("Order Date") },
    { id: 5, label: t("Status") },
  ];
  return (
    <div className="currOrdersList">
      <div className="row bg-dimGrey orderListTable py-3 ps-5 alignH justify-content-between">
        {orderTableTitles?.map(({ id, label }) => (
          <span
            className="col-2 f14 text-brightGrey sBold"
            style={{ textAlign: "left" }}
            key={id}
          >
            {label}
          </span>
        ))}
        <span className="col-1"></span>
      </div>
    </div>
  );
};

export default CurrentOrdersList;
